import {batch, computed, effect, signal} from "@preact/signals-react";

export const adminProductReviewFormTitle = signal(null)
export const adminProductReviewFormRowData = signal({})
export const adminProductReviewErrorFormData = signal({})
export const adminProductReviewFormIsLoading = signal(null)
export const adminProductReviewFormIsSkuMappingData = signal(false)

export const brandForm = signal([])
export const skuForm = signal([])
export const siteForm = signal([])
export const countryForm = signal(null)

// Computed
export const adminProductReviewFormIsOpen = computed(() => adminProductReviewFormTitle.value !== null)

export function fillCommonFormValue(newValues={}) {
    batch(() => {
        countryForm.value = newValues.countryForm ?? null
        siteForm.value = newValues.siteForm ?? []
        brandForm.value = newValues.brandForm ?? []
        skuForm.value = newValues.skuForm ?? null
    })
}